import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { sanitizeTaskHtml, plainTextToHtml } from "../utils/richText";

/**
 * عرض وصف التاسك: يستخدم textHtml (المنسّق) إذا موجود، وإلا text القديم.
 * الروابط الطويلة تنختصر وتنكسر داخل الكارت بدل ما تطلع برّه.
 */
export default function TaskText({ task, sx }) {
  const html = useMemo(
    () => sanitizeTaskHtml(task?.textHtml || plainTextToHtml(task?.text || "")),
    [task?.textHtml, task?.text]
  );

  return (
    <Box
      dir="rtl"
      dangerouslySetInnerHTML={{ __html: html }}
      sx={{
        lineHeight: 1.9,
        fontSize: 16,
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        minWidth: 0,
        // Tailwind يشيل الأرقام والنقاط من القوائم افتراضياً - نرجعها
        "& ol, & ul": { pr: 3.5, pl: 0, my: 0.5, listStylePosition: "outside" },
        "& ol": { listStyleType: "decimal" },
        "& ul": { listStyleType: "disc" },
        "& ul ul": { listStyleType: "circle" },
        "& li": { mb: 0.25 },
        "& p, & div": { m: 0 },
        "& a": {
          color: "#1565c0",
          textDecoration: "none",
          bgcolor: "rgba(25,118,210,0.08)",
          px: 0.75,
          borderRadius: 1,
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          verticalAlign: "bottom",
          direction: "ltr",
        },
        "& a:hover": { textDecoration: "underline" },
        ...sx,
      }}
    />
  );
}
